// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"96":"fdcb7272","234":"6cfd908b","409":"2d2f1fcd","496":"53421b0f","603":"993633c9","662":"4b09341f","738":"7fad4544","939":"8612427d"}[chunkId] + ".chunk.css";
};